var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-notes-add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE4B\\u200D\\u2642\\uFE0F-Punters",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Punters_Notes",
    transform: "translate(-1149.000000, -456.000000)",
    fill: "#99DA00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-notes-add",
    transform: "translate(1149.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.4181333,0 16,3.58186667 16,8 C16,12.4181333 12.4181333,16 8,16 C3.58186667,16 0,12.4181333 0,8 C0,3.58186667 3.58186667,0 8,0 Z M8,1.77777778 C4.56391111,1.77777778 1.77777778,4.56391111 1.77777778,8 C1.77777778,11.4360889 4.56391111,14.2222222 8,14.2222222 C11.4360889,14.2222222 14.2222222,11.4360889 14.2222222,8 C14.2222222,4.56391111 11.4360889,1.77777778 8,1.77777778 Z M8,3.55555556 C8.49096889,3.55555556 8.88888889,3.95486222 8.88888889,4.44444444 L8.88888889,4.44444444 L8.88888889,7.11111111 L11.5555556,7.11111111 C12.0465244,7.11111111 12.4444444,7.51041778 12.4444444,8 C12.4444444,8.49096889 12.0451378,8.88888889 11.5555556,8.88888889 L11.5555556,8.88888889 L8.88888889,8.88888889 L8.88888889,11.5555556 C8.88888889,12.0465244 8.48958222,12.4444444 8,12.4444444 C7.50903111,12.4444444 7.11111111,12.0451378 7.11111111,11.5555556 L7.11111111,11.5555556 L7.11111111,8.88888889 L4.44444444,8.88888889 C3.95347556,8.88888889 3.55555556,8.48958222 3.55555556,8 C3.55555556,7.50903111 3.95486222,7.11111111 4.44444444,7.11111111 L4.44444444,7.11111111 L7.11111111,7.11111111 L7.11111111,4.44444444 C7.11111111,3.95347556 7.51041778,3.55555556 8,3.55555556 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGreen);
export default __webpack_public_path__ + "static/media/add-green.b6e2dd1a196ad630c46bc7e076e4005d.svg";
export { ForwardRef as ReactComponent };